import styled from 'styled-components';
import { Form } from '@unform/web';
import { Modal as ModalComponent } from 'react-bootstrap';

export const Container = styled(Form)`
  .btn-add {
    border-radius: 8px;
    border: 1px solid #ff842f;
    background-color: #fff;
    color: #ff6900;
    height: 305px;
    max-height: 305px;
  }

  .cards-sponsor img {
    height: 123px;
    object-fit: contain;
    pointer-events: none;
  }

  .card {
    border-radius: 17px;
    border: 1px solid #d2d2d2;
  }

  .card p {
    color: #292623;
    font-family: 'Poppins';
    font-size: 18px;
    font-weight: 500;
    max-height: 54px;
    overflow: auto;
  }

  .link-ext {
    color: #8c8c8c;
    font-family: 'Poppins';
    font-size: 18px;
    font-weight: 500;

    span {
      width: 22px;
      height: 22px;
      background-color: #ff842f;
      border-radius: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .bg-gray {
    background-color: #b8b8b8;
    width: 32px;
    height: 32px;
  }

  .grab {
    cursor: grab;
  }

  .grab:active {
    cursor: grabbing;
  }
  .tooltip-total:after {
    background-color: #002f6c;
    color: #fff;
    border: 1px solid #002f6c;
    border-radius: 8px !important;
    box-sizing: border-box;
    content: attr(data-tooltip);
    display: none;
    padding: 10px 15px !important;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    position: absolute;
    top: -50px !important;
    bottom: auto;
    max-width: 250px;
    z-index: 10000;
  }

  .tooltip-total:hover:after {
    display: block;
  }
`;

export const Modal = styled(ModalComponent)`
  backdrop-filter: blur(3px);

  .title {
    color: #000;
    font-size: 26px;
    font-weight: 500;
  }

  .select {
    border-radius: 10px;
    border: 1px solid #d3d3d3;
  }

  .select input {
    height: 30px;
  }

  input {
    color: #202020;
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
  }

  input::placeholder {
    color: #d8d8d8;
  }

  h3 {
    font-size: 26px;
    font-weight: 500;
  }

  label {
    span {
      color: #000;
    }
  }

  #document {
    width: 100%;
  }

  .description {
    height: 70px;
  }

  .input {
    border: 1px solid rgba(221, 221, 221, 0.87);

    height: 40px;
    border-radius: 4px;

    input {
      color: #202020;
    }
  }

  span:not(.h6) {
    color: #878787;
    font-family: 'Poppins';
    font-size: 12px;
    font-weight: 400;
  }

  p:not(.h6) {
    color: #878787;
    font-family: 'Poppins';
    font-size: 12px;
    font-weight: 400;
    span {
      font-weight: 500;
    }
  }

  .name {
    color: #292623 !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    span {
      color: #8c8c8c !important;
      font-weight: 400 !important;
    }
  }

  .arquives {
    border-radius: 8px;
    border: 1px solid #e1e1e1;
  }

  .arquives img {
    width: 48px;
    height: 48px;
    border-radius: 4px;
    border: 1px solid #002f6c;
    object-fit: contain;
  }

  .label-modal {
    padding: 34px 30px;
    border-radius: 20px;
    border: 1px dashed #ff6900;
  }

  .label-modal {
    span:nth-child(2) {
      font-family: 'Roboto';
      color: #8c8c8c;
      font-size: 16px;
      font-weight: 400;
    }

    span:nth-child(3) {
      border-radius: 4px;
      border: 1px solid #ff6900;
      color: #ff6900;
      font-size: 16px;
      font-weight: 400;
      padding: 8px 16px;
    }

    span:nth-child(4) {
      color: #8c8c8c;
      font-family: 'Roboto';
      font-size: 12px;
      font-weight: 400;
    }
  }

  .variations {
    .variation-row {
      > div:first-child {
        width: 50px;

        .size {
          width: 32px;
          height: 32px;
          font-size: 16px;
          font-weight: 400;
          border-radius: 4px !important;
          border: 1px solid #ff842f !important;
          color: #ff842f !important;
          background-color: #fff;
          margin: 0 8px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

      > div:last-child {
        width: calc(100% - 50px);
      }

      + .variation-row {
        margin-top: 10px;
      }
    }
  }

  .height {
    height: 30px;
  }

  .btn-filter {
    border-radius: 4px;
    background-color: #ff6900;
    color: #fff;
  }

  .modal-content {
    border-radius: 8px;
    border: none;
  }

  .add-new-color {
    color: #d4d4d4;
    font-size: 16px;
    font-weight: 400;
    border-radius: 4px;
    border: 1px solid #e2e2e2;
  }
`;
